export default "__VITE_ASSET__DEJOJJx8__"